import CT from '@marketplace-ai/tags';
import { useFormContext, useWatch } from 'react-hook-form';
import { Table, TableActions, TableCard } from '~/components';
import { DetailFormValues } from '../types';
import { EDUCATION_DETAIL_COLUMNS } from './constants';

interface Props {
  deleteDetail: (id: number) => void;
  handleDetailOpen: () => void;
}
const TAGS = CT.academics.education.educationDetailTable;

export const EducationalDetailTable = (props: Props) => {
  const { deleteDetail, handleDetailOpen } = props;
  const { setValue } = useFormContext();
  const details: DetailFormValues[] = useWatch({ name: 'details' });

  const handleDetailDelete = (id: number, rowIdx: number) => {
    if (details[rowIdx]._id != undefined) {
      deleteDetail(details[rowIdx]._id);
    } else {
      const newDetails = details.filter((_, idx) => idx !== rowIdx);
      setValue('details', newDetails);
    }
  };

  return (
    <TableCard
      title="Education Details"
      addLabel="Add Detail"
      onAddClick={() => handleDetailOpen()}
      addBtnTag={TAGS.openCreateModal}
      layoutTag={TAGS.label}
      width="w-full"
    >
      <Table
        tags={TAGS}
        rowData={details}
        columns={EDUCATION_DETAIL_COLUMNS}
        loading={false}
        actions={[TableActions.delete]}
        onDelete={(id, rowIdx) => handleDetailDelete(id, rowIdx || 0)}
      />
    </TableCard>
  );
};
